<header class="header" id="header">
        <nav  (scroll)="onWindowScroll($event);" [ngClass]="{'navbar-inverse': checkedNews == true, 'navbar-container': checkedNews == false }">
            <div class="navbar-header">
                <div class="circulo lime image-logo"><span> BB </span></div>
            </div>
        </nav>
    </header>
    